import { Link } from "gatsby"
import React from 'react';
import BarHOME from '../components/BarHOME'
import NavBar1 from '../components/NavBar1'
import BarCLIENTS from '../components/BarCLIENTS'
import Footer from '../components/Footer'
import Helmet from 'react-helmet'
import IMG1 from '../assets/Produtos/Pt01.jpg'
import IMG2 from '../assets/Produtos/Pt02.jpg'
import IMG3 from '../assets/Produtos/Pt03.jpg'
import IMG4 from '../assets/Produtos/Pt04.jpg'
import IMG5 from '../assets/Produtos/Pt05.jpg'
import IMG6 from '../assets/Produtos/Pt06.jpg'
import IMG7 from '../assets/Produtos/Pt07.jpg'
import IMG8 from '../assets/Produtos/Pt08.jpg'
import IMG9 from '../assets/Produtos/Pt09.jpg'
import IMG10 from '../assets/Produtos/Pt10.jpg'
import IMG11 from '../assets/Produtos/Pt11.jpg'
import IMG12 from '../assets/Produtos/Pt12.jpg'
import IMG13 from '../assets/Produtos/Pt13.jpg'
import IMG14 from '../assets/Produtos/Pt14.jpg'
import IMG15 from '../assets/Produtos/Pt15.jpg'
import IMG16 from '../assets/Produtos/Pt16.jpg'
import IMG17 from '../assets/Produtos/Pt17.jpg'
import IMG18 from '../assets/Produtos/Pt18.jpg'

const Clients = () => {
    return (
        <div className='font-al-8'>
            <Helmet>
                <title>Celeste bolos doces & salgados - Clientes</title>
            </Helmet>
            <BarHOME />
            <NavBar1 />
            <BarCLIENTS />
            <h1 className='font-size-ronsof-p6 font-ronsof-nine text-center text-red-900 my-2 pt-5 mx-5 '>
                Alguns de nossos produtos
            </h1>
            <div className='color-al-5 flex flex-wrap my-10 justify-center'>
                <div>
                   <img className='w-56 mx-10 my-10 animation-ronsof-two' src={IMG1} alt='IMG1' /> 
                </div>
                
                <img className='w-56 mx-10 my-10 animation-ronsof-two' src={IMG3} alt='IMG3' />
                <img className='w-56 mx-10 my-10 animation-ronsof-two' src={IMG4} alt='IMG4' />
                <img className='w-56 mx-16 my-16 animation-ronsof-two' src={IMG5} alt='IMG5' />
                <img className='w-56 mx-16 my-16 animation-ronsof-two' src={IMG6} alt='IMG6' />
                <img className='w-56 mx-16 my-16 animation-ronsof-two' src={IMG7} alt='IMG7' />
                <img className='w-56 mx-16 my-16 animation-ronsof-two' src={IMG8} alt='IMG8' />
                <img className='w-56 mx-16 my-16 animation-ronsof-two' src={IMG9} alt='IMG9' />
                <img className='w-56 mx-16 my-16 animation-ronsof-two' src={IMG10} alt='IMG1' />
                <img className='w-56 mx-16 my-16 animation-ronsof-two' src={IMG11} alt='IMG2' />
                <img className='w-56 mx-16 my-16 animation-ronsof-two' src={IMG12} alt='IMG3' />
                <img className='w-56 mx-16 my-16 animation-ronsof-two' src={IMG13} alt='IMG4' />
                <img className='w-56 mx-16 my-16 animation-ronsof-two' src={IMG14} alt='IMG5' />
                <img className='w-56 mx-16 my-16 animation-ronsof-two' src={IMG15} alt='IMG6' />
                <img className='w-56 mx-16 my-16 animation-ronsof-two' src={IMG16} alt='IMG7' />
                <img className='w-56 mx-16 my-16 animation-ronsof-two' src={IMG17} alt='IMG8' />
                <img className='w-56 mx-16 my-16 animation-ronsof-two' src={IMG18} alt='IMG9' />
            </div>
            <div className='flex justify-center items-center my-10'>
                <Link to={`/pagecontato`} className="btn-ronsof-one-green-sb shadow-lg">
                    Faça seu pedido aqui
                </Link>
            </div>
            <div className='flex justify-center items-center my-10'>
                <Link to={`/`} className="text-red-900">
                    <p className='text-blue-700'>Página inicial</p>
                </Link>
            </div>
            <Footer />
        </div>
    )
}
export default Clients